import ActionTypes from "../../constants/action_types";

export default function clearDefinitionGroups() {
  return {
    type: ActionTypes.DEFINITION_GROUPS_CLEAR.SUCCESS,
  };
}
